

























































































import { CreateElement, VNode, VNodeDirective } from 'vue';
import { Component, Watch, Prop, Model } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { dropdown, SwDropdownUnit, DropdownDirValues } from '../dropdown-dir';
import SwTreeDropdownUnit from './components/sw-tree-dropdown-unit.vue';
import { SwIconButton } from '../sw-icon-button';
import { SwIcon } from '../sw-icon';
import { SwTransitionExpand } from '../sw-transition';
import { TreeDropdownNode } from './types';
import { SwChip } from '../sw-chip';
import { tooltip } from '../tooltip-dir';

@Component({
  components: {
    SwDropdownUnit,
    SwTreeDropdownUnit,
    SwIconButton,
    SwIcon,
    SwTransitionExpand,
    SwChip,
  },
  directives: {
    dropdown,
    tooltip,
  },
})
export default class SwTreeDropdownSelect extends SwExtendedVue {
  cssPrefix: string = 'sw-tree-dropdown-select';

  isDropdownVisible: boolean = false;
  closeWhenClickOutside: boolean = true;

  filterStr: string = '';
  readyToSearch: boolean = false;

  @Model('input', { required: true })
  value: TreeDropdownNode | TreeDropdownNode[];

  @Prop({ type: Boolean, required: false, default: false })
  disabled: boolean;

  @Prop({ type: Boolean, required: false, default: true })
  searchable: boolean;

  @Prop({ type: Boolean, default: false })
  full: boolean;

  selectedNodeOrNodes:TreeDropdownNode | TreeDropdownNode[] = this.value;

  @Watch('value')
  onValueChange() {
    this.selectedNodeOrNodes = this.value;
  }

  @Watch('selectedNodeOrNodes')
  onselectedNodeOrNodesChange() {
    this.$emit('input', this.selectedNodeOrNodes);
  }

  onClickBasicButton() {
    if (this.disabled) {
      this.isDropdownVisible = false;
      return;
    }
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  get dropdown(): DropdownDirValues {
    return {
      maxHeight: 1000,
      content: this.treeDropdownContent,
      visible: this.isDropdownVisible,
      placement: 'bottom-start',
      withArrow: false,
      onClickOutsidePopper: () => {
        if (this.closeWhenClickOutside) {
          this.isDropdownVisible = false;
        }
      },
    };
  }

  onFocusSearchBox(evt: Event) {
    if (this.disabled) {
      return;
    }
    this.readyToSearch = true;
    this.isDropdownVisible = true;
    evt.stopPropagation();
    const searchBox = this.$refs.searchBox as HTMLInputElement;
    this.$nextTick(() => {
      searchBox.focus();
    });
  }

  onSelectOption(selectedNode:TreeDropdownNode, toggleDropdown:boolean = true) {
    if (selectedNode.disabled) {
      return;
    }
    if (this.selectedNodeOrNodes instanceof Array) {
      const indexNode = this.indexOfSelectedNodes(selectedNode);
      if (indexNode === -1) {
        this.selectedNodeOrNodes.push(selectedNode);
      } else {
        this.selectedNodeOrNodes.splice(indexNode, 1);
      }
    } else {
      this.selectedNodeOrNodes = selectedNode;
    }
    if (toggleDropdown) {
      this.onClickBasicButton();
    }
  }

  @Prop({ required: true })
  treeDropdownData:TreeDropdownNode[];

  @Watch('isDropdownVisible')
  onDropdownVisibleChange() {
    this.exitSearchMode();
  }

  exitSearchMode() {
    if (this.isDropdownVisible) return;
    this.readyToSearch = false;
    setTimeout(() => { this.filterStr = ''; this.$emit('search', this.filterStr); }, 200);
  }

   /* tslint:disable */
  treeDropdownContent(h: CreateElement): VNode {
    const treeNodes:VNode[] = [];
    this.treeDropdownData.forEach((node:TreeDropdownNode) => {
      treeNodes.push(this.treeDropdownContentRecurse(h, node, 0));
    });

    const rootNode:VNode = (
      <div>
        {treeNodes}
      </div> as VNode
    )
    // {this.treeDropdownContentRecurse(h, this.treeDropdownData, [], 0)}
    return rootNode;
  }

  indexOfSelectedNodes (node:TreeDropdownNode) {
    if (this.selectedNodeOrNodes instanceof Array) {
      for (let i = 0; i < this.selectedNodeOrNodes.length; i += 1) {
        if (node.id === this.selectedNodeOrNodes[i].id) {
          return i;
        }
      }
      return -1;
    } else {
      return node.id === this.selectedNodeOrNodes.id ? 0 : -1;
    }
  }

  treeDropdownContentRecurse(h: CreateElement, treeDropdownNode:TreeDropdownNode, level:number): VNode {
    const divStyle = {
      'padding-left': (level * 10) + 'px',
      color: treeDropdownNode.disabled ? '#65656a' : 'inherit',
    }

    const checkmarkNodeStyle = {
      'margin-left': '10px',
    };

    const hasChildren = (treeDropdownNode.children.length > 0 );
    const expanded = treeDropdownNode.expanded;
    const searching = this.filterStr !== '';
    const showChildren = (expanded || searching) && hasChildren;

    let iconNode:VNode;
    if (!searching && hasChildren) {
      const iconName = expanded ? 'minus' : 'add';
      iconNode = (
        <SwIconButton
          nativeOn-click={(evt:Event) => {
            treeDropdownNode.expanded = !treeDropdownNode.expanded
            evt.stopPropagation();
          }}
          props-no-border={true}
          props-icon={{name:iconName, size: 10}}/> as VNode);
    } else {
      iconNode = (
        <SwIconButton
          props-no-border={true}
          props-icon={{size: 10}}
        /> as VNode);
    }

    let checkmarkNode:VNode;
    if (this.indexOfSelectedNodes(treeDropdownNode) !== -1) {
      checkmarkNode = (
        <SwIcon
          style={checkmarkNodeStyle}
          props-name="checkmark"
          props-color="#FF791A"
        /> as VNode);
    } else {
      checkmarkNode = (
        <SwIcon
          style={checkmarkNodeStyle}
          props-name=""
          props-color="transparent"
        /> as VNode);
    }

    const displayElement = treeDropdownNode.value.indexOf(this.filterStr) !== -1;

    const mainNodes:VNode[] = [];

    if (displayElement) {
      const directives: Partial<VNodeDirective>[] = [];
      if (treeDropdownNode.tooltip) {
        directives.push({ name: 'tooltip', value: treeDropdownNode.tooltip });
      }
      mainNodes.push(<SwTreeDropdownUnit
          {...{ directives }}
          props-disabled={treeDropdownNode.disabled}
          nativeOn-click={(evt:Event) => {
            this.onSelectOption(treeDropdownNode, !(this.selectedNodeOrNodes instanceof Array));
            evt.stopPropagation();
          }}
        >
          <span class="sw-flexbox sw-flexbox--between-justify sw-flexbox--center-items">
            <span style={divStyle}>
              {iconNode}
              {(typeof treeDropdownNode.label === 'function') ? treeDropdownNode.label(h) : treeDropdownNode.label}
            </span>
            <span {...{ class: ['sw-flexbox', 'sw-flexbox--center-items'] }}>
              {(typeof treeDropdownNode.otherContent === 'function') ? treeDropdownNode.otherContent(h) : treeDropdownNode.otherContent}
            {checkmarkNode}
          </span>
          </span>
        </SwTreeDropdownUnit> as VNode);
    }

    const childrenNodes:VNode[] = [];
    treeDropdownNode.children.forEach((child:TreeDropdownNode) => {
      childrenNodes.push(this.treeDropdownContentRecurse(h, child, level + 1));
    });

    const mainNodesInner:VNode[] = [];

    if (showChildren) {
      mainNodesInner.push(
        <div class={[`${this.cssPrefix}__grouping__children`, { [`${this.cssPrefix}__grouping__children--hidden`]: !showChildren } ]}>
          {childrenNodes}
        </div> as VNode
      );
    }

    mainNodes.push(
      <SwTransitionExpand props-duration={200}>
        {mainNodesInner}
      </SwTransitionExpand> as VNode);

    return (
      <div class="sw-tree-dropdown__grouping">
        {mainNodes}
      </div> as VNode);

  }

  /* tslint:disable */
  render(h: CreateElement): VNode {
    const nodes:VNode[] = [];
    if (this.searchable) {
      nodes.push(
          <SwIconButton
            props-icon={{name:'search', size:12}}
            props-no-border={true}
            props-disabled={this.disabled}
            class={[{ [`${this.cssPrefix}__searchbox--hidden`]: (this.readyToSearch) }]}
            nativeOn-click={(event: MouseEvent) => {
              this.onFocusSearchBox(event);
            }}
          /> as VNode
      );
      nodes.push(
        <input ref="searchBox"
          class={[`${this.cssPrefix}__searchbox`,
            'sw-flexbox__flex',
            { [`${this.cssPrefix}__searchbox--hidden`]: !this.readyToSearch },
          ]}
          on-input={(e:any) => { this.filterStr = e.target.value }}
          value={this.filterStr}
        /> as VNode
      );
    }

    const divStyle = {
      'margin-left': this.$slots.innerLabel ? '5px' : '0px',
    }

    let labelNode;

    if (this.selectedNodeOrNodes instanceof Array) {
      labelNode = [];
      this.selectedNodeOrNodes.forEach((node:TreeDropdownNode, i:number) => {
        labelNode.push(
          <SwChip
            on-request-remove={(event: MouseEvent) => {
              if (this.disabled) {
                return;
              } else {
                this.onSelectOption(node, false);
              }
            }}
            onClick={(event: MouseEvent) => {
              event.stopPropagation();
            }}
            style={{
              'margin-left': i == 0 && !this.$slots.innerLabel ? '0px' : '5px',
            }}
          >
            { typeof node.label === 'function' ? node.label(h) : node.label }
          </SwChip>
        )
      });
    } else {
      labelNode = (
        <span style={divStyle} class={['sw-flexbox', 'sw-flexbox--center-items']}>
          {(typeof this.selectedNodeOrNodes.label === 'function') ? this.selectedNodeOrNodes.label(h) : this.selectedNodeOrNodes.label}
        </span> as VNode
      );
    }

    nodes.push(
      <span class={[`${this.cssPrefix}__label`, 'sw-flexbox__flex', 'sw-flexbox', 'sw-flexbox--center-items']}>
        {
          this.$slots.innerLabel
        }
        {labelNode}
      </span> as VNode
    )
    return (
      <div
        class={[this.cssPrefix, 'sw-typo-default', 'sw-flexbox', 'sw-flexbox--inline', 'sw-flexbox--center-items',
          { [`${this.cssPrefix}--disabled`]: this.disabled,
            [`${this.cssPrefix}--searchable`]: this.searchable,
            [`${this.cssPrefix}--full`]: this.full,
          },
        ]}
        onClick={(event: MouseEvent) => {
          this.onClickBasicButton();
        }}
        { ...{ directives: [{name: 'dropdown', value: this.dropdown}] }}
      >
        {nodes}
        <div
          class={[`${this.cssPrefix}__icon`, { [`${this.cssPrefix}__icon--active`]: this.isDropdownVisible },
            'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--center-justify',
          ]}
        >
          <SwIcon props-name="arrow-up" props-size={14} props-rotate={180} />
        </div>
      </div>
    ) as VNode;
  }
}
